<template>
  <div>
    <h3 class="mainTitle">{{ node.name }} {{ roomName ? ' i ' + roomName.toLowerCase() : '' }}</h3>    
    <hr class="space">

    <p class="descr">Du visar nu detaljerna för {{ node.name }}, här kan du se vad som har hänt på din enhet tidigare, du kan redigera den och radera den om du vill. Allting uppdateras live så du behöver inte ladda om sidan för att se det senaste.</p>
    
    <div class="bootstrap-wrapper">
      <div class="container" style="padding:0px;margin:0px;">
        <div class="row">
          <div class="col-md-4" v-for="cap in node.capabilities" v-if="cap in $root.capabilities" style="cursor:pointer;" @click="showSensorValues(cap)">
            <div class="content">                
              <div class="title">{{ $root.capabilities[cap].name }}</div>
              <div v-if="cap in node.lastEvents">
                <div v-if="$root.capabilities[cap].type === 'number'">{{ node.lastEvents[cap].value }}{{ $root.capabilities[cap].unit }}</div>
                <div v-if="$root.capabilities[cap].type === 'boolean'">{{ $root.capabilities[cap].values[node.lastEvents[cap].value].name }}</div>
                <div style="font-size:10px;padding-top:3px;" v-if="'time' in node.lastEvents[cap]">{{ node.lastEvents[cap].time | moment("calendar") }}</div>
              </div>
              <div v-else>
                <i>Inget värde.</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div style="margin:8px;" v-if="showingCapabilityValues">
      <div style="padding:4px;background:#fcfcfc;border:1px solid #ededed;border-radius:4px;">
        <div v-if="!loadingCapabilityValues">
          <table>
            <thead>
              <tr>
                <th>Tid</th>
                <th>Värde</th>
              </tr>
            </thead>
            
            <tbody>
              <tr v-for="value in sensorValues">
                <td>{{ new Date(value[0]).toLocaleString() }}</td>
                <td>{{ value[1] }}{{value[2]}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>Laddar... vänta</div>
      </div>
    </div>

    <hr class="space">
    
    <div class="item">
      <vue-tabs centered>
        <!-- Aktivitetsloggen -->
        <v-tab title="Aktivitetslogg" v-if="!$root.isNX2">
          <h3>Senaste händelserna</h3>
              
          <div v-if="eventsLoaded">
            <div v-if="events.length">
              <table>
                <thead>
                  <tr>
                    <th>Tid</th>
                    <th>Namn</th>
                    <th align="right">Värde</th>
                  </tr>
                </thead>
                
                <tbody>
                  <tr class="nohover" v-for="event in events" v-if="event.name in $root.capabilities">
                    <td width="180">{{ event.time | moment("calendar") }}</td>
                    <td>{{ $root.capabilities[event.name].name }}</td>
                    <td align="right">{{ event.value }}{{ $root.capabilities[event.name].unit }}</td>
                  </tr>
                </tbody>
              </table>  
            </div>
            <div v-else>
              <p>Kunde inte hitta några händelser som hör till enheten.</p>
            </div>
          </div>
          <div v-else style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
            <half-circle-spinner :animation-duration="1000" :size="90" :color="'#033873'" />
          </div>
        </v-tab>
        
        <!-- Graferna för enheten -->
        <v-tab title="Grafer" v-if="isSensor && !$root.isNX2">
          <div class="descr">Graferna hämtas från din aktivitetslogg vilket innebär att om du har många enheter kan det finnas färre punkter att visa i graferna.</div>
          <hr class="space">
        
          <div v-for="cap in node.capabilities" v-if="cap in $root.capabilities && $root.capabilities[cap].type === 'number'">
            <h4>{{ $root.capabilities[cap].name }}</h4>
            <graph-view :nodeId="node.id" :capability="cap"></graph-view>
            <hr>
          </div>
        </v-tab>

        <!--<v-tab title="Finns i">
          <p class="descr">Här nedanför kan du se om din enhet finns i några schemaläggningar, scenarion eller automationer. Tänk på att dom du raderar enheten kommer alla nedanstående på något sätt att sluta och fungera.</p>
          
          <table v-if="triggers.length">
            <thead>
              <tr>
                <th>Namn</th>
                <th align="right">Typ</th>
              </tr>
            </thead>
    
            <tbody>
              <tr v-for="trigger in triggers" @click="showTrigger(trigger)">
                <td>{{ trigger.name }}</td>
                <td align="right">
                  <span v-if="'triggerType' in trigger">{{ trigger.triggerType == 'SebsonTrigger' ? 'Automation' : 'Schemaläggning' }}</span>
                  <span v-if="'color' in trigger">Scenario</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            Enheten finns inte i några schemaläggningar, automationer eller scenarion.
          </div>
        </v-tab>-->
        
        <!-- Redigera enheten -->
        <v-tab title="Alternativ">
          <table>
            <tbody>
              <tr @click="edit"><td><img src="../assets/edit.png" style="margin-bottom:-5px;"> Redigera enheten</td></tr>    
              <tr @click="edit" v-if="node.type === 'ZWave'"><td>Skicka konfigurationsparametrar</td></tr>
              <tr @click="favorite"><td style="color:#f1c40f;"><img src="../assets/star.png" style="margin-bottom:-5px;"> <span v-if="!node.favorite">Markera som favorit</span><span v-else>Ta bort favoritmarkering</span></td></tr> 
              <tr @click="hide"><td><img src="../assets/hide.png" style="margin-bottom:-5px;"> <span v-if="!node.hideInApp">Dölj enheten</span><span v-else>Unhide</span></td></tr> 
              <tr @click="remove"><td style="color:#e74c3c;"><img src="../assets/delete.png" style="margin-bottom:-5px;"> Radera enheten</td></tr> 
            </tbody>
          </table>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js'
  import { HalfCircleSpinner } from 'epic-spinners'
  import graphView from './views/graphViewForNode'
  import {VueTabs, VTab} from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/paper.css'
  
  export default {
    name: 'HelloWorld',
    components: {
      HalfCircleSpinner,
      graphView,
      VueTabs,
      VTab
    },
    data () {
      return {
        node: {},
        events: [],
        eventsLoaded: false,
        triggers: [],
        limitLog: 10,
        sensorValues: [],
        showingCapabilityValues: false,
        loadingCapabilityValues: false
      }
    },
    created () {
      // Hämta information om noden
      this.node = this.$root.data.nodes.find(node => node.id == this.$route.params.id)
      
      if (!this.node) {
        HTTP.get('nodes/' + this.$route.params.id)
        .then(res => res.data)
        .then(json => this.node = json)
      }
      
      if (!this.$root.isNX2) {
      HTTP.get('eventlog?limit=0,' + this.limitLog + '&where=sourceNode=' + this.$route.params.id)
      .then(res => res.data)
      .then(json => {
        this.eventsLoaded = true
        this.events = json
      })
      }


      // Hämta automationer så vi kan ta reda på om enheten finns i några automationer
      // eller ej.
      /*HTTP.get(`nodes/${this.$route.params.id}/included`)
      .then(res => res.data)
      .then(json => {

        for (const index in [...json.triggers, ...json.scenarios]) {
          const item = json[index]

          this.triggers.push({
            name: item.name
          })
        }
      })*/

      eventbus.$on('nodeEvent', (json) => {
        if (json.sourceNode === this.$route.params.id) {
          let newArray = this.events.slice()
          newArray.unshift(json)
          this.events = newArray
        }
      })
    },
    methods: {
      showSensorValues (capability) {
        if (this.$root.isNX2 && this.$root.capabilities[capability].type === 'number') {
          const unit = this.$root.capabilities[capability].unit
          this.showingCapabilityValues = true
          this.loadingCapabilityValues = true
          
          HTTP.get(`ex/sensor/${this.$route.params.id}/${capability}?days=1`)
          .then(res => res.data)
          .then(data => {
            this.sensorValues = data
            .split('\n')
            .filter(x => x.length)
            .map(x => x.split(','))
            .map(([ time, value ]) => ([ parseInt(time), parseFloat(value), unit ]))
            .reverse()
            .slice(0, 15)
            
            this.loadingCapabilityValues = false
          })
        }

      },
      showTrigger (trigger) {
        let name = ''
        if ('color' in trigger) {
          name = 'scenarion_edit'
        } else if (trigger.triggerType === 'TimeTrigger') {
          name = 'schemalaggningar_edit'
        } else {
          name = 'automationer_edit'
        }

        this.$router.push({
          name: name,
          params: {
            id: trigger.id
          }
        })
      },
      
      trim (string, length) {
        return (string && string.length > length ? string.substr(0, length) + '...' : string)
      },
      
      edit () {
        this.$router.push({
          name: 'spara_enhet',
          params: {
            id: this.$route.params.id
          }
        })
      },
      
      favorite () {
        this.node.favorite = !this.node.favorite
      },
      
      hide () {
        this.node.hideInApp = !this.node.hideInApp
        HTTP.post('nodes/' + this.node.id, this.node)
        
      },
      
      setValue (capability) {
        const method = this.$root.capabilities[capability].values[this.node.lastEvents[capability].value].method

        const obj = {
          cap: capability,
          method: method,
        }
        
        HTTP.post('nodes/' + this.node.id + '/call', obj)
        .then(res => res.data)
        .then(json => {
          
        })
      },
      
      remove () {
        // Är det Z-Wave skickar vi till exkludering
        if (this.isZWave) {
          this.$router.push({
            name: 'remove_zwave'
          })
        } else {
          if (confirm('Är du säker på att du vill radera enheten?')) {
            HTTP.delete('nodes/' + this.node.id)
            .then(res => res.data)
            .then(json => {})
            
            this.$root.removeNode(this.node.id)
            
            this.$router.push({
              name: 'enheter'
            })
          }
        }
      },
      
      showGraphs (capability) {
        this.$router.push({
          name: 'grafer',
          query: {
            node: this.node.id,
            capability: capability
          }
        })
      }
    },
    
    computed: {
      isZWave () {
        return this.node.type === 'ZWave'
      },
      
      roomName () {
        const room = this.$root.data.rooms.find(room => room.id === this.node.roomId)
        return (this.node.roomId != 0 && room ? room.name : null)
      },
      
      isSensor () {
        const caps = Object.keys(this.$root.capabilities).filter(key => {
          if (this.$root.capabilities[key].type === 'number') {
            return key
          }
        })
        return this.node.capabilities.some(cap => caps.includes(cap))
      }
    },
    
    destroyed () {
      eventbus.$off('nodeEvent')
    }
  }
</script>

<style scoped>
  .col-md-4 .content {
    border:1px solid #e8e8e8;
    padding:12px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius:2px;
    height:120px;
    text-align: center;
    margin-bottom:10px;
    border-bottom:3px solid #e8e8e8;
  }
    
  .col-md-4 .title {
    font-weight: bold;
    padding-bottom:5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/enhet.vue